var map = {
	"./img_old_data00.png": 695,
	"./img_old_data01.png": 57678,
	"./img_old_data02.png": 29477,
	"./img_old_data03.png": 60,
	"./img_old_data04.png": 83667,
	"./img_old_data05.png": 44810,
	"./img_old_data06.png": 93793,
	"./img_old_data07.png": 9176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56483;